import {UIComponent} from "@webfruits/core";
import {CoreAssets} from "../../core/CoreAssets";

/******************************************************************
 * BackgroundSystem
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class BackgroundSystem extends UIComponent {

    /******************************************************************
     * Properties
     *****************************************************************/

    // no properties yet

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor() {
        super("background-system");
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    public updateStyles() {
        this.applyStyle({
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage: "url(" + CoreAssets.BACKGROUND + ")",
            backgroundRepeat: "repeat",
            backgroundSize: "250px 250px"
        })
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    // no private methodes yet

    /******************************************************************
     * Events
     *****************************************************************/

    // no events yet

}
